// 숫자 3자리 콤마 포맷터 (0/undefined/null 안전)
export const formatAmount = (value) => {
	if (value === undefined || value === null || value === '') return '0'
	const str = value.toString()
	return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
